<template>
    <div class="vote">
        <div>
            <div v-if="votes.total > 0" style="text-align: left; margin-top:5px;">
                <chart-progress classes="green-secondary small"
                                title="<span class='material-icons'>thumb_up</span> Move Forward"
                                :animation-speed="300"
                                :progress="getPercentage(votes.yes, votes.total)"
                                :legend="votes.yes + ' vote' + (votes.yes == 1 ? '' : 's')">
                </chart-progress>
                <chart-progress classes="red small"
                                title="<span class='material-icons'>thumb_down</span> Pass"
                                :animation-speed="300"
                                :progress="getPercentage(votes.no, votes.total)"
                                :legend="votes.no + ' vote'  + (votes.no == 1 ? '' : 's')">

                </chart-progress>
            </div>
            <table align="center" style="margin-top: 5px;">
                <tr>
                    <td>
                        <a @click.prevent="submitVote('yes')" href=""
                           v-bind:class="{active:currentVote == 'yes'}"
                           class="button icon outline  green-secondary ">
                            <span v-if="loading && currentVote == 'yes'"  class="material-icons spin">sync</span>
                            <span v-else class="material-icons">thumb_up</span>
                        </a>
                        &nbsp;
                        <a @click.prevent="submitVote('no')" href="" class="button red outline icon "
                           v-bind:class="{active:currentVote == 'no'}">
                            <span v-if="loading && currentVote == 'no'"  class="material-icons spin">sync</span>
                            <span v-else class="material-icons">thumb_down</span>
                        </a>
                    </td>
                </tr>
            </table>
        </div>
    </div>
</template>

<script>
    import chartProgress from './chartProgress';
    export default {
        components: {
            chartProgress
        },
        created: function () {
            this.currentVote = this.vote
            if(this.currentVote && this.currentVote != '') {
                this.getResults()
            }

        },
        data:function() {
            return {
                loading:false,
                currentVote:false,
                votes:{
                    yes:0,
                    no:0,
                    total:0
                }
            }
        },
        props:{
            notes:{ type:Array },
            vote:{type:String},
            results:{type:String},
            save:{ type:String },
        },
        methods: {
            submitVote(vote) {
                if(this.save && vote != this.currentVote) {
                    this.loading = true
                    this.currentVote = vote
                    var e = this
                    $.ajax({
                        type:'PATCH',
                        url:this.save,
                        data: {
                            vote:vote
                        },
                        success:function(response) {
                            e.loading = false;
                            if(response.status == 200) {
                                var data = response.data;
                                e.getResults()
                                if(data.timeline != undefined) {
                                    $.get('/projects/' + data.timeline,function(timeline) {
                                        $('.timeline').html('<div id="modal-render-timeline"></div>');
                                        var res = Vue.compile(timeline.content)
                                        var vm = new Vue({
                                            el:'#modal-render-timeline',
                                            render: res.render,
                                            staticRenderFns: res.staticRenderFns
                                        });
                                    });
                                }
                            } else {
                                e.currentVote = ''
                                alert(response.msg)
                            }
                        }
                    });
                }
                this.currentVote = vote
            },
            getPercentage(number, total) {
              return (number / total) * 100
            },
            getResults() {
                if(this.results) {
                    var e = this
                    $.get(this.results,function(response) {
                       if(response.data) {
                           e.processResults(response.data)
                       }
                    });
                }
            },
            processResults(data) {
                if(data.votes) {
                    this.votes = data.votes
                }
            }
        },
        mounted:function() {
        }
    }
</script>
